import { performShowToast, performHideToast } from '../../../features/toast/slice';

export const showToast = (message, type = 'success', duration = 4000) => dispatch => {
    dispatch(performShowToast({ message, type, duration }));
};

export const hideToast = () => dispatch => {
    dispatch(performHideToast());
};